import React from "react";
import { cn } from "../../lib/utils";

interface CheckboxProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
}

export function Checkbox({
  className,
  checked,
  onCheckedChange,
  ...props
}: CheckboxProps) {
  return (
    <label className="relative inline-block before:content-[''] before:absolute before:inset-[-10px] before:cursor-pointer">
      <input
        type="checkbox"
        className={cn(
          "w-12 h-12 rounded-xl border-3 border-bub-dark-blue text-blue-600 bg-gray-100",
          className,
        )}
        checked={checked}
        onChange={(e) => onCheckedChange?.(e.target.checked)}
        {...props}
      />
    </label>
  );
}
